import { render, staticRenderFns } from "./CouplesForm.vue?vue&type=template&id=053fa558&scoped=true&lang=pug&"
import script from "./CouplesForm.vue?vue&type=script&lang=js&"
export * from "./CouplesForm.vue?vue&type=script&lang=js&"
import style0 from "./CouplesForm.vue?vue&type=style&index=0&id=053fa558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fa558",
  null
  
)

export default component.exports